/**
 * The scroll story: hero -> methodology -> explorer.
 *
 * Scroll position drives the camera through three keyframes and decides when the
 * explorer chrome appears. The story fades out before the UI arrives so the two
 * never overlap.
 */
import { DIMS } from '../model.js';
import { reduceMotion } from '../env.js';
import { cam, lerpLon, setAutoRotate, isDragging } from '../globe/scene.js';
import { closeDrawer } from './drawer.js';
import { h } from '../untrusted.js';

const KEYS=[ // [lat, lon, dist] per section: intro / method / explorer
  [22, 12, 2.95],[38, 55, 2.3],[25, 18, 2.6]
];
function onScroll(){
  const vh=innerHeight;
  const p=Math.min(2, Math.max(0, scrollY/vh));
  const i=Math.min(1, Math.floor(p)), f=p-i;
  const a=KEYS[i], b=KEYS[Math.min(2,i+1)];
  const e=f<.5? 2*f*f : 1-Math.pow(-2*f+2,2)/2;
  if(!isDragging() && !document.body.classList.contains('drawer-open')){
    cam.tLat=a[0]+(b[0]-a[0])*e;
    cam.tLon=lerpLon(a[1],b[1],e);
    cam.tDist=a[2]+(b[2]-a[2])*e;
  }
  const explorer=p>1.45;
  document.body.classList.toggle('story-out', p>1.18);   // story fades before explorer UI arrives — no overlap
  document.body.classList.toggle('explorer', explorer);
  if(explorer) setAutoRotate(false);
  else if(!reduceMotion && p<0.2) setAutoRotate(true);
  document.getElementById('scrollcue').style.opacity = p>0.12?0:1;
  const active = explorer?2 : Math.round(Math.min(1,p));
  document.querySelectorAll('#dots button').forEach(b=> b.classList.toggle('on', +b.dataset.s===active));
}
addEventListener('scroll', onScroll, {passive:true});

/* section navigation: dots + About button — always a way back */
function gotoSection(s){
  const vh=innerHeight;
  const top = s===2 ? document.body.scrollHeight : s*vh;
  if(s<2) closeDrawer();
  scrollTo({top, behavior: reduceMotion?'auto':'smooth'});
}
document.querySelectorAll('#dots button').forEach(b=> b.onclick=()=> gotoSection(+b.dataset.s));
document.getElementById('aboutBtn').onclick=()=> gotoSection(0);

/* section reveal + counters */
const io=new IntersectionObserver(es=>es.forEach(en=>{
  if(en.isIntersecting){
    en.target.classList.add('seen');
    en.target.querySelectorAll('[data-count]').forEach(el=>{
      if(el.dataset.done) return; el.dataset.done=1;
      const target=+el.dataset.count, t0=performance.now();
      const step=now=>{ const k=Math.min(1,(now-t0)/1100); el.textContent=Math.round(target*(1-Math.pow(1-k,3))); if(k<1) requestAnimationFrame(step) };
      requestAnimationFrame(step);
    });
  }
}),{threshold:.35});
document.querySelectorAll('.sect').forEach(s=>io.observe(s));
document.getElementById('dimtags').innerHTML = String(h`${DIMS.map(d=>h`<span class="dimtag">${d}</span>`)}`);
document.getElementById('ctaExplore').onclick=()=> gotoSection(2);

export function initStory() {
  addEventListener('scroll', onScroll, { passive: true });
  document.querySelectorAll('#dots button').forEach(b => b.onclick = () => gotoSection(+b.dataset.s));
  document.getElementById('aboutBtn').onclick = () => gotoSection(0);
  document.querySelectorAll('.sect').forEach(s => io.observe(s));
  document.getElementById('dimtags').innerHTML = String(h`${DIMS.map(d => h`<span class="dimtag">${d}</span>`)}`);
  document.getElementById('ctaExplore').onclick = () => gotoSection(2);
  onScroll();
}
